import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    Dialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    DialogActions as MuiDialogActions,
    IconButton,
    Typography,
    Slide,
    LinearProgress,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { CLOSE_MODAL_WINDOW } from '../../../modules/App/redux/constants/modalWindow.constants';


const styles = (theme) => ({
    root: {
        margin: 0,
        padding: 12,
    },
    closeButton: {
        position: 'absolute',
        // right: theme.spacing(1),
        // top: theme.spacing(1),
        right: 6,
        top: 4,
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const {
        children,
        classes,
        isLoading,
        onClose, ...other
    } = props;

    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {
                onClose && (
                    <IconButton aria-label="close" className={classes.closeButton} disabled={isLoading} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                )
            }
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

class ModalWindow extends React.Component {
    handleClickSave = () => {
        const { onSave } = this.props;
        onSave();
    };

    handleClickClose = () => {
        const { dispatch } = this.props;
        dispatch({ type: CLOSE_MODAL_WINDOW });
    };

    render() {
        const {
            isOpen,
            maxWidth,
            isLoading,
            content,
        } = this.props;

        return (
            <div>
                <Dialog
                    onClose={this.handleClose}
                    aria-labelledby="modalWindow"
                    open={isOpen}
                    fullWidth
                    maxWidth={maxWidth}
                    disableEscapeKeyDown
                    TransitionComponent={Transition}
                >
                    <DialogTitle id="modalWindow" onClose={this.handleClickClose} isLoading={isLoading}>
                        {
                            content.header
                        }
                    </DialogTitle>
                    {
                        isLoading && <LinearProgress />
                    }
                    <DialogContent dividers>
                        {
                            content.body
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClickSave} color="primary" disabled={isLoading}>
                            Save & Close
                        </Button>
                        <Button onClick={this.handleClickClose} color="secondary" disabled={isLoading}>
                            Discard
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ ...state.App.modalWindow });

export default connect(mapStateToProps)(ModalWindow);



// WEBPACK FOOTER //
// ./src/common/components/modalWindow/index.js